import * as ACTION from './constants';

const initialState = {
  submitted: false,
  isSubmitting: false,
  form: null,
  clean: true,
};

export default function reducers(state = initialState, action) {
  switch(action.type) {
    case ACTION.FORM_BASE:
      return {...initialState};
    case ACTION.FORM_SUBMITTED:
      return {...state,
        isSubmitting: false
      };
    case ACTION.FORM_SUBMITTING:
      return {...state,
        isSubmitting: true
      };
    case ACTION.FORM_SET:
      action.form.checkValidity();
      return {...state,
        form: action.form,
        clean: action.initial
      };
    default:
      return state;
  }
}
